export enum StatusType {
    INACTIVE,
    ACTIVE,
    COMPLETED
}